import { IDamageDetailState } from './damage-detail.props';

export const initialState: IDamageDetailState = {
  editForm: {
    type: 'common',
    formFields: []
  }
};
